import { Box, Paper } from "@material-ui/core";
import { useStyles } from "../styled";
import { Skeleton } from "@material-ui/lab";

function VisibilityScopeSkeleton({ idPrefix }: { idPrefix: string }) {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.title}>
        <Skeleton variant="text" width="30%" height={28} />
        <Skeleton variant="text" width="65%" height={20} />
      </Box>
      <div style={{ marginTop: 12 }}>
        {[1, 2, 3].map(i => (
          <Box
            key={`${idPrefix}-scope-skeleton-${i}`}
            display="flex"
            alignItems="flex-start"
            mb={1.5}
          >
            <Skeleton
              variant="circle"
              width={18}
              height={18}
              style={{ marginRight: 8, marginTop: 2 }}
            />
            <Box>
              <Skeleton variant="text" width={120} height={22} />
              <Skeleton variant="text" width={240} height={18} />
            </Box>
          </Box>
        ))}
      </div>
    </>
  );
}

export default function Loader() {
  const classes = useStyles();

  return (
    <Paper className={classes.container}>
      <Box>
        <Skeleton variant="text" width="30%" height={32} />
        <Box mt={1}>
          <Skeleton variant="text" width="60%" height={20} />
        </Box>
      </Box>
      <Box className={classes.title}>
        <Skeleton variant="text" width="25%" height={28} />
        <Skeleton variant="text" width="50%" height={20} />
      </Box>
      <div className={classes.optionContainer}>
        {[1, 2, 3].map(i => (
          <Box
            key={`auth-skeleton-${i}`}
            display="flex"
            alignItems="center"
            mb={1}
          >
            <Skeleton
              variant="rect"
              width={18}
              height={18}
              style={{ marginRight: 8, borderRadius: 2 }}
            />
            <Skeleton variant="text" width={120} height={24} />
          </Box>
        ))}
      </div>

      {/* Session Duration Section */}
      <Box className={classes.title}>
        <Skeleton variant="text" width="20%" height={28} />
        <Skeleton variant="text" width="45%" height={20} />
      </Box>
      <div className={classes.optionContainer}>
        <Skeleton
          variant="rect"
          width="20%"
          height={56}
          style={{ marginTop: 10, borderRadius: 4 }}
        />
      </div>

      {/* Request Approval History Section */}
      <VisibilityScopeSkeleton idPrefix="request-approval" />

      {/* Temporary Hold History Section */}
      <VisibilityScopeSkeleton idPrefix="temporary-hold" />

      {/* Submit Button */}
      <Box mt={1}>
        <Skeleton
          variant="rect"
          width={100}
          height={36}
          style={{ borderRadius: 4 }}
        />
      </Box>
    </Paper>
  );
}
